import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=0fc36c24&scoped=true&lang=pug&"
var script = {}
import style0 from "./Subscription.vue?vue&type=style&index=0&id=0fc36c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc36c24",
  null
  
)

export default component.exports